import { create } from 'zustand';
import { AskRequest, ReportRow } from '@hone-automation/common';
import { UIReportTransaction } from 'types/askcustomer';

export interface CellDateRange {
  start: string;
  end: string;
  reportId?: string;
}

export interface PendingFlagData {
  cellTitle: string;
  cellDate: CellDateRange;
  cellAmount: number;
  parentTitle: string | null;
  resolvedLocationId: string;
  reportId: string | null;
  dataRows: ReportRow[];
  audit: any;
  trxFlagged: AskRequest[] | undefined;
  existingFlagId?: string;
  transaction?: UIReportTransaction;
}

interface FlagCreationState {
  pendingFlag: PendingFlagData | null;
  setPendingFlag: (data: PendingFlagData | null) => void;
  clearPendingFlag: () => void;
}

export const useFlagCreationStore = create<FlagCreationState>(set => ({
  pendingFlag: null,
  setPendingFlag: (data: PendingFlagData | null) => set({ pendingFlag: data }),
  clearPendingFlag: () => set({ pendingFlag: null }),
}));
